import AutoloadViews from "@galaxy/modules/Core/resources/js/AutoloadViews";

require('./datatables');

AutoloadViews.load('crud::form', require.context('./form', true, /.(js|vue)$/));
AutoloadViews.load('crud::components', require.context('./components', true, /.(js|vue)$/));
AutoloadViews.load('crud::datatable', require.context('./datatable', true, /.(js|vue)$/));
AutoloadViews.load('crud::helpers', require.context('./helpers', true, /.(js|vue)$/));
